import * as React from "react";

function SvgEllipsisHSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M14.903 12A2.901 2.901 0 0112 14.903 2.901 2.901 0 019.097 12 2.901 2.901 0 0112 9.097 2.901 2.901 0 0114.903 12zm4.194-2.903A2.901 2.901 0 0016.193 12a2.901 2.901 0 002.904 2.903A2.901 2.901 0 0022 12a2.901 2.901 0 00-2.903-2.903zm-14.194 0A2.901 2.901 0 002 12a2.901 2.901 0 002.903 2.903A2.901 2.901 0 007.806 12a2.901 2.901 0 00-2.903-2.903z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgEllipsisHSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
